module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "total-consumption",
    attrs: {
      "id": "total-consumption"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82875eee","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/TotalConsumption.vue
// module id = 943
// module chunks = 25